<template>
  <div id="GivBack">
    <BreadCrumb :items="breadcrumbItems" />

    <v-card elevation="1" class="pt-5 mt-1">
      <div class="header d-flex justify-space-between pr-5 align-center">
        <h1>Mercadorias a Devolver</h1>
      </div>

      <v-tabs class="px-8 py-4">
        <v-tab>Hierarquia</v-tab>
        <v-tab>Gerenciamento Rápido</v-tab>

        <v-tab-item>
          <div class="table p-relative">
            <table-title-row :columnsOptions="columnsOptions"></table-title-row>
            <v-progress-linear v-if="isStopsLoading" indeterminate color="primary"></v-progress-linear>
            <template v-if="nodes.length">
              <template v-for="(node, nodeIndex) in nodes">
                <div :key="node.data.id">
                  <table-body-row
                    :node="node"
                    :nodeIndex="nodeIndex"
                    :columns="columns"
                    :itemsDropdown="itemsDropdown"
                    :lengthDataToTruncate="14"
                    :type="'Parada'"
                    :enableCheckbox="true"
                    :enableDropdown="true"
                    :selectedCheckbox="selectedCheckbox"
                    @onExpand="onExpand(node)"
                    @actionsDropdown="actionsDropdown"
                    @changeCheckbox="changeSelectedCheckbox"
                  >
                  </table-body-row>

                  <Status :nodeIndex="nodeIndex" :status="node.data.status" />

                  <v-row v-if="node.open" style="margin-top: 0">
                    <v-col cols="12">
                      <v-card :loading="loading">
                        <v-card-text class="p-5">
                          <table-title-row :columnsOptions="columnsDeliveriesOptions"></table-title-row>

                          <template v-for="(deliveries, deliveriesIndex) in node.children">
                            <div :key="deliveries.data.id">
                              <table-body-row
                                :node="deliveries"
                                :nodeIndex="deliveriesIndex"
                                :columns="columnsDeliveries"
                                :itemsDropdown="itemsDropdown"
                                :lengthDataToTruncate="12"
                                :type="'Entrega'"
                                :stopIndex="nodeIndex"
                                :enableCheckbox="true"
                                :enableDropdown="true"
                                @onExpand="onExpand(deliveries)"
                                @actionsDropdown="actionsDropdown"
                                @changeCheckbox="changeSelectedCheckbox"
                              >
                              </table-body-row>

                              <Status :nodeIndex="deliveriesIndex" :status="deliveries.data.status" />

                              <v-row v-if="deliveries.open" style="margin-top: 0">
                                <v-col cols="12">
                                  <v-card :loading="loading">
                                    <v-card-text class="p-5">
                                      <table-title-row :columnsOptions="columnsNfeOptions"></table-title-row>

                                      <template v-for="(nfe, nfeIndex) in deliveries.children">
                                        <div :key="nfe.data.id">
                                          <table-body-row
                                            :node="nfe"
                                            :nodeIndex="nfeIndex"
                                            :columns="columnsNfe"
                                            :itemsDropdown="itemsDropdownNfe"
                                            :lengthDataToTruncate="13"
                                            :type="'Nota Fiscal'"
                                            :enableCheckbox="true"
                                            :enableDropdown="true"
                                            :stopIndex="nodeIndex"
                                            :deliveryIndex="deliveriesIndex"
                                            @onExpand="onExpand(nfe)"
                                            @actionsDropdown="actionsDropdownNfe"
                                            @changeCheckbox="changeSelectedCheckbox"
                                          >
                                          </table-body-row>

                                          <Status :nodeIndex="nfeIndex" :status="nfe.data.nfeStatus" />
                                        </div>
                                      </template>
                                    </v-card-text>
                                  </v-card>
                                  <div class="mt20"></div>
                                </v-col>
                              </v-row>
                            </div>
                          </template>
                        </v-card-text>
                      </v-card>
                      <div class="mt20"></div>
                    </v-col>
                  </v-row>
                </div>
              </template>
            </template>
            <template v-else>
              <div class="d-flex justify-center pt-6 pb-2" style="color: grey">Nenhum registro encontrado.</div>
            </template>
            <div class="mt50"></div>
            <div class="d-flex justify-space-between">
              <v-pagination v-model="page" :length="paginate.totalPages" :total-visible="7"></v-pagination>
              <v-btn elevation="2" color="info" @click="openStatus"> ATUALIZAR STATUS </v-btn>
            </div>
          </div>
        </v-tab-item>

        <v-tab-item>
          <div class="table p-relative">
            <table-title-row :columnsOptions="columnsOptions"></table-title-row>
            <v-progress-linear v-if="isStopsLoading" indeterminate color="primary"></v-progress-linear>
            <template v-if="nodesFast.length">
              <template v-for="(node, nodeIndex) in nodesFast">
                <div :key="node.data.id">
                  <table-body-row
                    :node="node"
                    :nodeIndex="nodeIndex"
                    :columns="columns"
                    :itemsDropdown="itemsDropdown"
                    :lengthDataToTruncate="13"
                    :type="'Parada'"
                    :enableCheckbox="true"
                    :enableDropdown="true"
                    @onExpand="onExpandFast(node)"
                    @actionsDropdown="actionsDropdown"
                    @changeCheckbox="changeSelectedCheckbox"
                  >
                  </table-body-row>

                  <Status :nodeIndex="nodeIndex" :status="node.data.status" />

                  <v-progress-linear
                    v-if="nfeLoading && nodeIndex === currentNfeLoading"
                    indeterminate
                    color="primary"
                  ></v-progress-linear>

                  <v-row v-if="node.open" class="px-2" style="margin-top: 0">
                    <v-col cols="12">
                      <v-card>
                        <v-card-text class="p-5">
                          <table-title-row :columnsOptions="columnsNfeOptions"></table-title-row>

                          <template v-for="(nfe, nfeIndex) in node.children">
                            <div :key="nfe.data.id">
                              <table-body-row
                                :node="nfe"
                                :nodeIndex="nfeIndex"
                                :columns="columnsNfe"
                                :itemsDropdown="itemsDropdownNfe"
                                :lengthDataToTruncate="13"
                                :type="'Nota Fiscal'"
                                :enableCheckbox="true"
                                :enableDropdown="true"
                                :stopIndex="nodeIndex"
                                @onExpand="onExpand(nfe)"
                                @actionsDropdown="actionsDropdownNfe"
                                @changeCheckbox="changeSelectedCheckboxFast"
                              >
                              </table-body-row>

                              <Status :nodeIndex="nfeIndex" :status="nfe.data.nfeStatus" />
                            </div>
                          </template>
                        </v-card-text>
                      </v-card>
                      <div class="mt20"></div>
                    </v-col>
                  </v-row>
                </div>
              </template>
            </template>
            <template v-else>
              <div class="d-flex justify-center pt-6 pb-2" style="color: grey">Nenhum registro encontrado.</div>
            </template>
            <div class="mt50"></div>
            <div class="d-flex justify-space-between">
              <v-pagination v-model="page" :length="paginate.totalPages" :total-visible="7"></v-pagination>
              <v-btn elevation="2" color="info" @click="openStatus"> ATUALIZAR STATUS </v-btn>
            </div>
          </div>
        </v-tab-item>
      </v-tabs>
    </v-card>

    <MessagesError
      :type="errorsType"
      :errors="errors"
      :error500="error500"
      @closeMessages="
        errors = [];
        error500 = null;
      "
    />

    <UpdateStatusNfe
      :selectedCheckbox="selectedCheckbox"
      :nfeSelected="nfeSelected"
      :open="updateStatus"
      role="ToBeReturned"
      @closeUpdateStatusNfe="closeUpdateStatusNfe"
    />

    <HistoricNfe :id="nfeSelectedId" :open="historic" @closeHistoricNfe="historic = false" />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import BreadCrumb from '../../../components/BreadCrumb.vue';
import MessagesError from '../../../components/MessagesError.vue';

import TableTitleRow from '../../../components/Table/Table-Title-Row.vue';
import TableBodyRow from '../../../components/Table/Table-Body-Row.vue';
import Status from '../../../components/Table/Status.vue';

import maskCPF from '../../../utils/maskCPF';
import maskCNPJ from '../../../utils/maskCNPJ';
import maskData from '../../../utils/maskData';
import maskPrice from '../../../utils/maskPrice';
import maskWeight from '../../../utils/maskWeight';
import changeCheckbox from '../../../utils/changeSelectedCheckbox';

import HistoricNfe from '../../../components/Nfe/HistoricNfe.vue';
// import UpdateStatusGivBack from "../../../components/Quarantine/UpdateStatusGivBack.vue";
import UpdateStatusNfe from '../../../components/Nfe/UpdateStatusNfe.vue';

export default {
  name: 'GiveBack',
  components: {
    BreadCrumb,
    MessagesError,
    HistoricNfe,
    TableTitleRow,
    TableBodyRow,
    Status,
    // UpdateStatusGivBack,
    UpdateStatusNfe
  },
  data: () => ({
    nfeLoading: false,
    isStopsLoading: false,
    currentNfeLoading: null,
    error500: null,
    breadcrumbItems: [
      {
        text: 'Início',
        disabled: false,
        to: '/start'
      },
      {
        text: 'Mercadorias a Devolver',
        disabled: false,
        to: '/givback'
      }
    ],
    columns: ['type', 'recipientName', 'cityName', 'weight', 'price', 'actions'],
    columnsOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      {
        value: 'recipientName',
        text: 'Destinatário'
      },
      {
        value: 'cityName',
        text: 'Cidade'
      },
      {
        value: 'weight',
        text: 'Peso'
      },
      {
        value: 'price',
        text: 'Preço'
      },
      { value: 'actions', text: 'Ações' }
    ],
    columnsDeliveries: ['type', 'number', 'deliveryForecast', 'senderName', 'weight', 'actions'],
    columnsDeliveriesOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      {
        value: 'number',
        text: 'Número CTE'
      },
      {
        value: 'deliveryForecast',
        text: 'Previsão de Entrega'
      },
      {
        value: 'senderName',
        text: 'Enviado por'
      },
      {
        value: 'weight',
        text: 'Peso'
      },
      { value: 'actions', text: 'Ações' }
    ],
    columnsNfe: ['type', 'justificationQuarantine', 'number', 'price', 'weight', 'completionDate', 'actions'],
    columnsNfeOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      {
        value: 'justificationQuarantine',
        text: 'Justificativa'
      },
      { value: 'number', text: 'Número NFE' },
      { value: 'price', text: 'Preço da NF' },
      { value: 'weight', text: 'Peso da NF' },
      { value: 'completionDate', text: 'Data de Conclusão' },
      { value: 'actions', text: 'Ações' }
    ],
    columnsNfeFast: ['type', 'recipientName', 'senderName', 'number', 'price', 'weight', 'actions'],
    columnsNfeFastOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      {
        value: 'recipientName',
        text: 'Destinatário'
      },
      {
        value: 'senderName',
        text: 'Remetente'
      },
      { value: 'number', text: 'Número NFE' },
      { value: 'price', text: 'Preço da NF' },
      { value: 'weight', text: 'Peso da NF' },
      { value: 'actions', text: 'Ações' }
    ],
    errors: [],
    errorsType: null,
    loading: false,
    nodes: [],
    nodesFast: [],
    selectedCheckbox: [],
    itemsDropdown: [{ title: 'Atualizar Status' }],
    itemsDropdownNfe: [{ title: 'Atualizar Status' }, { title: 'Histórico' }],
    updateStatus: false,
    updateNumber: false,
    historic: false,
    canhoto: false,
    nfeSelected: [],
    nfeSelectedId: null
  }),
  computed: {
    ...mapState('GivBackStore', ['paginate']),
    ...mapGetters('GivBackStore', ['getStops']),
    ...mapGetters('NfeStore', ['getNfeByStatus']),
    page: {
      get() {
        return this.paginate.pageNumber;
      },
      set(value) {
        this.setPageNumber(value);

        this.fetchAllStops();
      }
    },
    getColumns() {
      const newColumns = this.columns.map((item) => {
        const newItem = this.columnOptions.filter((option) => {
          return option.value === item;
        });

        return newItem[0];
      });
      return newColumns;
    }
  },
  mounted() {
    this.fetchAllStops();
    this.fetchAllNfe();
  },
  methods: {
    ...mapActions('GivBackStore', ['fetchStopsByID', 'fetchDeliveriesByID', 'fetchNfesByID']),
    ...mapActions('NfeStore', ['getNfesByStatusIdForManagementGivBack', 'getNfesByStopAndStatusesIds']),
    ...mapMutations('GivBackStore', ['setItemPerPage', 'setPageNumber']),
    changeSelectedCheckbox(item, children, shipmentIndex, cargoIndex, stopIndex, deliveryIndex, nfeIndex) {
      this.selectedCheckbox = changeCheckbox(
        this.selectedCheckbox,
        item,
        children,
        stopIndex,
        deliveryIndex,
        nfeIndex,
        this.nodes[stopIndex]
      );
    },
    changeSelectedCheckboxFast(item, children, shipmentIndex, cargoIndex, stopIndex, deliveriesIndex) {
      this.selectedCheckbox = changeCheckbox(
        this.selectedCheckbox,
        item,
        children,
        cargoIndex,
        stopIndex,
        deliveriesIndex,
        this.nodesFast[stopIndex]
      );
    },
    closeUpdateStatusNfe(hasChange, message) {
      this.updateStatus = false;
      this.nfeSelected = [];
      if (hasChange) {
        this.fetchAllStops();
        this.fetchAllNfe();
      }
      if (message) {
        this.errors = message.errors;
        this.errorsType = message.errorsType;
        this.error500 = message.error500;
      }
    },
    openStatus() {
      if (this.selectedCheckbox.length === 0) {
        this.errors = ['Nenhum item selecionado.'];
        this.errorsType = 'info';
      } else {
        this.updateStatus = true;
      }
    },
    transformWeight(weight) {
      return maskWeight(weight);
    },
    transformPrice(price) {
      return maskPrice(price);
    },
    transformCpfOrCnpj(str) {
      if (str.length === 11) {
        return maskCPF(str);
      }

      return maskCNPJ(str);
    },
    transformDate(date) {
      return maskData(date);
    },
    actionsDropdown(index, node) {
      this.nfeSelected.push(node.data);
      if (index === 0) {
        this.updateStatus = true;
      }
    },
    actionsDropdownNfe(index, node) {
      this.nfeSelectedId = node.data.id;
      this.nfeSelected.push(node.data);
      if (index === 0) {
        this.updateStatus = true;
      } else if (index === 1) {
        this.historic = true;
      }
    },
    async fetchAllNfe() {
      this.isStopsLoading = true;
      try {
        const newStops = this.getStops.map((item, index) => {
          return {
            key: index,
            data: {
              ...item,
              price: this.transformPrice(item.price),
              cityName: item['address']['cityName'],
              type: 'Parada',
              actions: ''
            },
            children: [],
            type: 'Stops',
            open: false,
            selected: false
          };
        });
        console.log('newStops', newStops);

        this.nodesFast = newStops;
      } catch (err) {
        console.error(err);
      } finally {
        setTimeout(() => {
          this.viewCheckbox = true;
          this.selectedCheckbox = [];
        }, 0);
      }
    },
    async fetchAllStops() {
      this.isStopsLoading = true;
      try {
        await this.fetchStopsByID();

        const newStops = this.getStops.map((item, index) => {
          return {
            key: index,
            data: {
              ...item,
              price: this.transformPrice(item.price),
              cityName: item['address']['cityName'],
              type: 'Parada',
              actions: ''
            },
            children: [],
            type: 'Stops',
            open: false,
            selected: false
          };
        });

        this.nodes = newStops;
      } catch (err) {
        console.error(err);
      } finally {
        await this.fetchAllNfe();
        this.isStopsLoading = false;
        setTimeout(() => {
          this.viewCheckbox = true;
          this.selectedCheckbox = [];
        }, 0);
      }
    },
    async onExpand(selected) {
      this.loading = true;
      if (selected.type === 'Deliveries') {
        const idStop = Number(selected.key.split('-')[0]);
        const idDelivieres = Number(selected.key.split('-')[1]);

        this.nodes[idStop].children[idDelivieres].open = !this.nodes[idStop].children[idDelivieres].open;
        try {
          const nfes = await this.fetchNfesByID(selected.data.id);

          const Nfes = nfes.map((item, index) => {
            return {
              key: selected.key + '-' + index,
              data: {
                ...item,
                type: 'Nota Fiscal',
                price: this.transformPrice(item.price),
                completionDate: this.transformDate(item.completionDate)
              },
              type: 'Nfes',
              open: false,
              selected: false
            };
          });

          if (this.nodes[idStop].children[idDelivieres].selected) {
            Nfes.map((item) => {
              item.selected = true;
              this.selectedCheckbox.push(item.data);
            });
          }
          this.nodes[idStop].children[idDelivieres].children = Nfes;
        } catch (err) {
          console.error(err);
        } finally {
          this.loading = false;
        }
      }
      if (selected.type === 'Stops') {
        const idStop = Number(selected.key);

        this.nodes[idStop].open = !this.nodes[idStop].open;
        try {
          const stops = await this.fetchDeliveriesByID(selected.data.id);

          const newDeliveries = stops.map((item, index) => {
            return {
              key: selected.key + '-' + index,
              data: {
                ...item,
                deliveryForecast: this.transformDate(item.deliveryForecast),
                type: 'Entrega'
              },
              children: [],
              type: 'Deliveries',
              open: false,
              selected: false
            };
          });

          if (this.nodes[idStop].selected) {
            newDeliveries.map((item) => {
              item.selected = true;
              this.selectedCheckbox.push(item.data);
            });
          }

          this.nodes[idStop].children = newDeliveries;
        } catch (err) {
          console.error(err);
        } finally {
          this.loading = false;
        }
      }
    },
    async onExpandFast(node) {
      const { key, open } = node;

      this.nodesFast[key].open = !this.nodesFast[key].open;

      if (open) {
        return;
      }

      this.nfeLoading = true;
      this.currentNfeLoading = key;

      const { id: stopId } = node.data;
      const statusesIds = [8, 15];

      try {
        const data = await this.getNfesByStopAndStatusesIds({ stopId, statusesIds });

        const nfes = data.map((item, index) => {
          return {
            key: node.key + '-' + index,
            data: {
              ...item,
              type: 'Nota Fiscal',
              price: this.transformPrice(item.price),
              completionDate: this.transformDate(item.completionDate)
            },
            type: 'QuickNfe',
            open: false,
            selected: false
          };
        });

        this.nodesFast[key].children = nfes;

        if (node.selected) {
          const selectedIds = this.selectedCheckbox.map((item) => item.id);
          this.nodesFast[key].children.map((nfe) => {
            nfe.selected = true;
            if (!selectedIds.includes(nfe.data.id)) {
              this.selectedCheckbox.push(nfe.data);
            }
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.nfeLoading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.p-treetable {
  max-width: 100%;
  overflow: auto;
}

.w-100-all {
  width: 100%;

  table {
    width: 100%;
    text-align: left;

    tr {
      padding: 0 15px;
    }
  }
}

.image-container {
  width: 100% !important;
}

.text-align-left {
  text-align: left;
}

.text-table {
  padding: 15px 0px 0px 0px !important;
}

.text-table-title {
  text-align: center;
  justify-content: center;
}
</style>
